import { render, staticRenderFns } from "./MenuOptions.vue?vue&type=template&id=d2c48926&scoped=true&"
import script from "./MenuOptions.vue?vue&type=script&lang=js&"
export * from "./MenuOptions.vue?vue&type=script&lang=js&"
import style0 from "./MenuOptions.vue?vue&type=style&index=0&id=d2c48926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c48926",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
